export default __webpack_public_path__ + "static/indosatLogo-9b778d3c8ba3dac5cf39dfa32465bbb0.png";